/**
 * Sanitizes a URL by removing query parameters and keeping only the origin and pathname.
 *
 * @param url - The URL to sanitize (can be absolute or relative)
 * @returns Sanitized URL containing only origin and pathname, or undefined if input is invalid
 */
export function sanitizeUrl(url: string | undefined): string | undefined {
    if (!url) {
        return;
    }

    try {
        const urlObj = new URL(url);
        return `${urlObj.origin}${urlObj.pathname}`;
    } catch {
        const queryParamIndex = url.indexOf('?');
        if (queryParamIndex === -1) {
            return url;
        }
        return url.substring(0, queryParamIndex);
    }
}
